import React from 'react';
import Modal from 'react-modal';

const EstimateModal = () => (
  <div className="pa3 flex-auto overflow-y-auto">
    <div className="tc">
      <h3 className="f2 fw3 tc sans-serif black mb3">How it Works</h3>
      <div className="flex flex-wrap">
        <div className="pa3 tc w-100 w-50-m w-25-l">
          <img className="center h3" src="/Content/Images/Blinds.com/Icon_Window.svg" alt="" />
          <p className="f4 tc pt3 ma2 dark-blue sans-serif">Shop</p>
          <p className="tc f6 ma0 sans-serif lh-copy">
            Browse our selection to find just
            <br /> what you&#39;re looking for.
          </p>
        </div>
        <div className="pa3 tc w-100 w-50-m w-25-l">
          <img className="center h3" src="/Content/Images/Blinds.com/Icon_MeasureTape.svg" alt="" />
          <p className="f4 tc pt3 ma2 dark-blue sans-serif">Measure</p>
          <p className="helvetica tc f6 ma0 sans-serif lh-copy">
            DIY measure your windows or
            <br />
            book a pro-measure appointment.
          </p>
        </div>
        <div className="pa3 tc w-100 w-50-m w-25-l">
          <img className="center h3" src="/Content/Images/Blinds.com/Icon_Truck.svg" alt="" />
          <p className="f4 tc pt3 ma2 dark-blue sans-serif">Order</p>
          <p className="helvetica tc f6 ma0 sans-serif lh-copy">
            Customize and order the perfect fit
            <br />
            for your window coverings.
          </p>
        </div>
        <div className="pa3 tc w-100 w-50-m w-25-l">
          <img className="center h3" src="/Content/Images/Blinds.com/Icon_Wrench.svg" alt="" />
          <p className="f4 tc pt3 ma2 dark-blue sans-serif">Install</p>
          <p className="helvetica tc f6 ma0 sans-serif lh-copy">
            DIY install or book an installation
            <br />
            appointment once products arrive.
          </p>
        </div>
      </div>
      <div className="mt3 cf flex justify-center">
        <a className="gcc-btn gcc-btn-secondary" href="/estimatebuilder/new">
          Get Started
        </a>
      </div>
    </div>
  </div>
);

Modal.setAppElement('body');

export default EstimateModal;
